'use strict';

//  If changing, align rule types in constants.py
module.exports = {
  priceGroupOverrideRule: 'priceGroupOverrideRule',
  globalRule: 'globalRule',
  pricingGroupRule: 'pricingGroupRule',
  defaultRule: 'defaultRule',
};
